<div class="body audit-body">
    
    <div class="section" *ngIf="(assignedUsers$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">done</mat-icon>
            <span class="text">Eingeteilte Nutzer</span>
            <span class="counter">{{(assignedUsers$|async)?.length}}</span>

        </div>

        <div class="section" *ngFor="let entry of (assignedUsers$|async)">

            <div class="entry">

                <div class="text">{{entry.userId|user|async}}</div>
    
            </div>

        </div>

    </div>

</div>